import React from 'react';

export default function AccessCheckError({ message, onRetry }: { message: string; onRetry: () => void }) {
  return <section className="u2-card" style={{ maxWidth: 560, margin: '48px auto' }}>
    <div className="u2-cardInner">
      <h1 className="u2-title">Проверка входа</h1>
      <p role="alert" className="u2-subtitle">{message}</p>
      <button type="button" className="u2-btn is-primary" onClick={onRetry}>Повторить проверку</button>
    </div>
  </section>;
}
